
export default function About() {
  return (
    <section id="hakkimizda" className="py-24 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%232D3436' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center bg-[#C17F59]/10 px-5 py-2.5 rounded-lg mb-6">
              <i className="ri-building-line text-[#C17F59] mr-2"></i>
              <span className="text-[#C17F59] text-sm font-semibold uppercase tracking-wider">Hakkımızda</span>
            </div>

            <h2 className="text-5xl lg:text-6xl font-bold text-[#2D3436] mb-6 tracking-tight leading-tight">
              Güvenilir Çözüm<br />Ortağınız
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong className="text-[#2D3436]">KGM Danışmanlık</strong>, ISO belgelendirme, kalibrasyon ve dijital çözümler alanında uzman bir danışmanlık firmasıdır.
            </p>

            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              Farklı sektörlerde faaliyet gösteren işletmelere; dokümantasyon, süreç tasarımı, yazılım entegrasyonu ve akreditasyon süreçlerinde uçtan uca destek sunar.
            </p>

            <p className="text-base text-gray-600 mb-10 leading-relaxed">
              Amacımız, müşterilerimizin kalite, güvenlik ve verimlilik seviyesini sürdürülebilir şekilde yükseltmektir.
            </p>

            {/* Stats Cards */}
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-gradient-to-br from-[#C17F59] to-[#A66B47] rounded-xl p-5 text-white shadow-lg">
                <div className="text-3xl font-bold mb-1">10+</div>
                <div className="text-xs opacity-90 font-medium">Yıl Deneyim</div>
              </div>
              <div className="bg-gradient-to-br from-[#2D3436] to-[#3D4446] rounded-xl p-5 text-white shadow-lg">
                <div className="text-3xl font-bold mb-1">200+</div>
                <div className="text-xs opacity-90 font-medium">Proje</div>
              </div>
              <div className="bg-gradient-to-br from-[#C17F59] to-[#A66B47] rounded-xl p-5 text-white shadow-lg">
                <div className="text-3xl font-bold mb-1">15+</div>
                <div className="text-xs opacity-90 font-medium">Sektör</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.12)]">
              <img
                src="https://public.readdy.ai/ai/img_res/06381d49280e75513808a26b11230b2b.jpg"
                alt="KGM Ekibi"
                className="w-full h-auto object-cover"
              />
              
              {/* Overlay Badge */}
              <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 rounded-lg bg-[#C17F59]/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-3xl text-[#C17F59]"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-[#2D3436] mb-1">TÜRKAK Akrediteli</div>
                    <div className="text-xs text-gray-600">Kalibrasyon Laboratuvarı</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Element */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#C17F59] rounded-xl opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#2D3436] rounded-xl opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
